export const QUANTITY_PROMOS_IN_ROW = 2;
